var render = function render(){var _vm=this,_c=_vm._self._c;return _c('flickity',{ref:"flickity",staticClass:"flickity-container",attrs:{"options":_vm.flickityOptions}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }